<script lang="ts">
  import { type ComponentProps, type SvelteComponent } from 'svelte';

  import { getDialog } from '@components/layout/dialogs/functions';
  import { DialogTypes } from '@components/ui/dialog';

  export let dialogType: DialogTypes;
  export let dialogProps: ComponentProps<SvelteComponent>;
</script>

{#await getDialog(dialogType) then LazyComponent}
    <LazyComponent {...dialogProps} />
{/await}
